export interface AuthTranslations {
  loginTitle: string; registerTitle: string; forgotPasswordTitle: string; newPasswordTitle: string;
  email: string; password: string; firstName: string; lastName: string;
  loginButton: string; registerButton: string; sendResetLink: string; updatePassword: string;
  forgotPassword: string; noAccount: string; hasAccount: string; rememberMe: string; backToLogin: string;
  checkEmail: string; confirmEmail: string; loginError: string; registerError: string;
  passwordTooShort: string; resetEmailSent: string; passwordUpdated: string; invalidResetLink: string;
  newPassword: string; profile: string; admin: string; logout: string; save: string;
  profileSaved: string; plan: string; loginRequired: string;
  verifying: string; invalidLink: string; linkExpired: string;
  registrationClosed: string; registrationClosedMessage: string; registrationClosedWaitlist: string;
  // Early access (registration closed + waitlist enabled)
  earlyAccessBadge?: string;
  earlyAccessTitle?: string;
  earlyAccessDescription?: string;
  earlyAccessBenefit1?: string;
  earlyAccessBenefit2?: string;
  earlyAccessBenefit3?: string;
  earlyAccessCta?: string;
  earlyAccessLoginHint?: string;
  privacyConsent?: string;
  privacyPolicy?: string;
  imprint?: string;
  // Account deletion (self-service request)
  deleteAccount?: string;
  deleteAccountDesc?: string;
  requestDeleteAccount?: string;
  deleteAccountConfirmTitle?: string;
  deleteAccountConfirmDesc?: string;
  deleteAccountConfirmButton?: string;
  deleteAccountReason?: string;
  deleteAccountReasonPlaceholder?: string;
  deletionRequested?: string;
  deletionPendingHint?: string;
  withdrawDeletionRequest?: string;
  deletionRequestSuccess?: string;
  deletionWithdrawn?: string;
  deletionRequestError?: string;
  typeWord?: string;
  cancel?: string;
  // GDPR data export
  exportData?: string;
  exportDataDesc?: string;
  exportDataButton?: string;
  exportDataLoading?: string;
  exportDataSuccess?: string;
  exportDataError?: string;
  exportBeforeDeleteHint?: string;
  exportNow?: string;
}

export interface AdminTranslations {
  title: string; search: string; addUser: string; editUser: string; create: string;
  name: string; emailCol: string; role: string; planCol: string; status: string; actions: string;
  blocked: string; active: string; unconfirmed: string; noUsers: string;
  userDeleted: string; userUpdated: string; userCreated: string;
  passwordLength: string;
  maintenanceMode: string; maintenanceReason: string; maintenanceReasonPlaceholder: string;
  maintenanceActive: string; maintenanceInactive: string; maintenanceSaved: string;
  settingsSaved: string; appVersion: string; versionLabel: string;
  maintenanceBypass: string;
  usersTab: string; settingsTab: string; paymentsTab: string; lastLogin: string; online: string; offline: string; never: string;
  paymentsOverview: string; subscriptionsTab: string; paymentHistoryTab: string; paymentErrorsTab: string; activityLogTab: string;
  activeSubscriptions: string; monthlyRecurring: string; cancellations: string; pastDueWarning: string;
  stripeStatus: string; stripeUnreachable: string; stripeConnected: string; stripeError: string;
  newCustomers: string; revenue: string; activeUsers: string;
  // Account deletion requests (admin)
  pendingDeletions?: string;
  pendingDeletionsBanner?: string;
  showDeletionRequests?: string;
  showAllUsers?: string;
  deleteAllRequested?: string;
  deletionRequestedBadge?: string;
  bulkDeleteTitle?: string;
  bulkDeleteDesc?: string;
  bulkDeleteConfirm?: string;
  bulkDeleteProgress?: string;
  gracePending?: string;
  graceReady?: string;
  deletionRequestedOn?: string;
  deletionReason?: string;
  waitingFor?: string;
  daysShort?: string;
  of?: string;
  cancel?: string;
  typeWord?: string;
  deletionRequestedAlert?: string;
  deletionNoReason?: string;
  gracePeriodRemaining?: string;
  gracePeriodEnded?: string;
  // Insights dashboard
  insightsTab?: string;
  totalUsers?: string;
  paid?: string;
  free?: string;
  paidShare?: string;
  freeShare?: string;
  newUsersRange?: string;
  waitlistTotal?: string;
  waitlistPending?: string;
  invitesSent?: string;
  invitesConverted?: string;
  conversionRate?: string;
  invitesNotConverted?: string;
  staleInvites?: string;
  customizeCards?: string;
  hideCard?: string;
  showCard?: string;
  onlineNow?: string;
  onlineNowDetail?: string;
  onlinePeak?: string;
  onlinePeakDetail?: string;
  onlinePeakNoRecord?: string;
  onlineSinceTrackingStart?: string;
  onlineSinceReset?: string;
  resetOnlinePeak?: string;
  resetOnlinePeakTitle?: string;
  resetOnlinePeakDescription?: string;
  resetOnlinePeakConfirm?: string;
  refreshOnlinePresence?: string;
  onlinePeakResetSuccess?: string;
  onlinePresenceLoadError?: string;
  // Insights categories
  catUsers?: string;
  catRevenue?: string;
  catWaitlist?: string;
  catSystem?: string;
  // Insights extra cards
  activeUsers?: string;
  pendingDeletions?: string;
  earlyAccessUsers?: string;
  earlyAccessDetail?: string;
  activeSubscriptions?: string;
  mrr?: string;
  revenue?: string;
  cancellations?: string;
  newCustomers?: string;
  stripeStatus?: string;
  stripeHealthy?: string;
  stripeUnhealthy?: string;
  stripeLive?: string;
  stripeTest?: string;
  subsMonthly?: string;
  subsYearly?: string;
  subsLifetime?: string;
  subsMonthlyDetail?: string;
  subsYearlyDetail?: string;
  subsLifetimeDetail?: string;
  // Sidebar navigation
  navUsers?: string;
  navCommunity?: string;
  navBusiness?: string;
  navSystem?: string;
  navUserList?: string;
  navInsights?: string;
  navWaitlist?: string;
  navFeedback?: string;
  navChangelog?: string;
  navProject?: string;
  navFaq?: string;
  navPayments?: string;
  navProfitability?: string;
  navProducts?: string;
  navSettings?: string;
  navSamples?: string;
}

export interface SubscriptionTranslations {
  title: string;
  monthly: string; yearly: string; lifetime: string;
  manage: string; upgrade: string;
  renewsOn: string; expiresOn: string;
  lifetimeAccess: string;
  autoRenewalOn: string; autoRenewalOff: string;
  pastDue: string;
  paymentHistory: string;
}

export interface PracticeTrackerTranslations {
  title: string; subtitle: string;
  today: string; songs: string; rudiments: string; warmups: string; history: string;
  addSong: string; addRudiment: string; addWarmup: string; addItem: string;
  songTitle: string; songTitlePlaceholder: string; artist: string; artistPlaceholder: string;
  difficulty: string; selectDifficulty: string; beginner: string; intermediate: string; advanced: string;
  personalNotes: string; notesPlaceholder: string;
  rudimentName: string; selectRudiment: string;
  exerciseName: string; exerciseNamePlaceholder: string;
  exerciseDescription: string; descriptionPlaceholder: string;
  durationMin: string; repetitions: string;
  interval: string;
  intervals: { noSchedule: string; daily: string; every2: string; every3: string; every5: string; weekly: string };
  save: string; cancel: string;
  itemAdded: string; itemUpdated: string; itemDeleted: string;
  noSongs: string; noRudiments: string; noWarmups: string;
  noItemsToday: string; addItemsHint: string;
  progress: string; finishSession: string; sessionFinished: string; startSession: string;
  launchMetronome: string; openDrumPattern: string;
  streakDays: string; totalSessions: string; itemsCompleted: string;
  last90Days: string; items: string; recentSessions: string; noSessions: string;
  premiumRequired: string; unlockPractice: string;
  startTimer: string; stopTimer: string; practicing: string;
  totalPracticeTime: string; practiceByCategory: string;
  warmupTime: string; rudimentTime: string; songTime: string;
  originalBpm: string; practiceBpm: string; bpmProgress: string;
  skipToday: string; skippedToday: string; undoSkip: string;
  noSessionRecorded: string; noSessionPlanned: string; goToToday: string;
  startFreeSession: string; pickItemsForToday: string;
  addToToday: string; removeFromToday: string; adhocItems: string;
  selectItemsTitle: string; selectItemsDesc: string;
  noItemsInLibrary: string; done: string;
  sessionSummaryTitle: string; sessionTotalDuration: string;
  sessionItemsCompleted: string; sessionGreatWork: string; sessionClose: string;
  sessionTitleLabel: string; sessionTitlePlaceholder: string; sessionSaveTitle: string; sessionTitleSaved: string;
  sessionAutoTitleFallback: string; sessionAutoTitleMoreOne: string; sessionAutoTitleMoreMany: string;
  sessionHistoryAll: string; sessionHistoryOpen: string; sessionHistoryLoadMore: string;
  sessionHistoryToday: string; sessionHistoryYesterday: string;
  linkedPatterns: string; linkPattern: string;
  unlinkPattern: string; noPatterns: string; createPatternFirst: string;
  saveAsTemplate: string; loadTemplate: string;
  templateName: string; templateNamePlaceholder: string;
  templateSaved: string; templateDeleted: string;
  noTemplates: string; templateLoaded: string; deleteTemplate: string;
  goalProgress: string;
  goalType: string;
  goalNone: string;
  goalTime: string;
  goalReps: string;
}

export interface DataResetTranslations {
  title: string;
  description: string;
  resetStats: string;
  resetStatsDesc: string;
  resetSessions: string;
  resetSessionsDesc: string;
  resetAll: string;
  resetAllDesc: string;
  confirmTitle: string;
  confirmDescription: string;
  typeWord: string;
  confirmWord: string;
  cancel: string;
  confirm: string;
  resetSuccess: string;
  resetError: string;
}

export interface ImprintTranslations {
  title: string;
  legalInfoTitle: string;
  contactTitle: string;
  disputeTitle: string;
  disputeText: string;
  euDisputeTitle: string;
  euDisputeText: string;
  privacyLink: string;
}

export interface PrivacyTranslations {
  title: string;
  responsibleTitle: string;
  responsibleText: string;
  principlesTitle: string;
  principlesText: string;
  hostingTitle: string;
  hostingText: string;
  accountTitle: string;
  accountIntro: string;
  accountEmail: string;
  accountPassword: string;
  accountPracticeData: string;
  accountSupabaseText: string;
  accountSupabaseInfo: string;
  cookiesTitle: string;
  cookiesText: string;
  cookiesNecessary: string;
  analyticsTitle: string;
  analyticsIntro: string;
  analyticsCookies: string;
  analyticsPrivacyFramework: string;
  analyticsRevoke: string;
  analyticsLegal: string;
  rightsTitle: string;
  rightsText: string;
  rightsContact: string;
  rightsAuthority: string;
  securityTitle: string;
  securityText: string;
  currentTitle: string;
  currentText: string;
  imprintLink: string;
}

export interface CookieConsentTranslations {
  title: string;
  description: string;
  acceptAll: string;
  rejectAll: string;
  managePreferences: string;
  settingsDescription: string;
  confirmSelection: string;
  necessaryLabel: string;
  necessaryDescription: string;
  functionalLabel: string;
  functionalDescription: string;
  analyticsLabel: string;
  analyticsDescription: string;
  marketingLabel: string;
  marketingDescription: string;
  privacyPolicy: string;
  imprint: string;
  settingsAriaLabel: string;
}

export interface FeedbackTranslations {
  submitTitle: string; typeBug: string; typeFeature: string; typeFeedback: string;
  titleLabel: string; titlePlaceholder: string; descriptionLabel: string; descriptionPlaceholder: string;
  stepsLabel: string; stepsPlaceholder: string; expectedLabel: string; expectedPlaceholder: string;
  actualLabel: string; actualPlaceholder: string; screenshots: string; addScreenshot: string;
  submit: string; submitted: string;
  subscribeEmail: string; subscribedToast: string; unsubscribedToast: string;
  subscribeButton: string; unsubscribeButton: string; globalEmailEnabled: string;
  boardTitle: string; featureRequests: string; bugTracker: string; whatsNew: string;
  noItems: string; loginToVote: string; noChangelog: string;
  submitIdea: string; reportBug: string;
  supportTab: string; submitSupport: string; supportTitle: string;
  supportSubjectLabel: string; supportSubjectPlaceholder: string;
  supportMessageLabel: string; supportMessagePlaceholder: string;
  contactEmailLabel: string; contactEmailPlaceholder: string;
  contactEmailHint: string; contactEmailRequired: string;
  supportLoginHint: string; supportLogin: string; noSupportItems: string;
  loggedInAsLabel: string; loggedInHint: string; supportLoginInstead: string;
  supportSubmitted: string;
}

export interface WaitlistTranslations {
  title: string;
  subtitle: string;
  emailPlaceholder: string;
  gdprConsent: string;
  gdprLink: string;
  submit: string;
  success: string;
  alreadyRegistered: string;
  accountExists: string;
  disabled: string;
  invalidEmail: string;
  completeProfileTitle: string;
  completeProfileSubtitle: string;
  setPassword: string;
  profileCompleted: string;
  incompleteProfileBanner: string;
  incompleteProfileCta: string;
  adminTab: string;
  adminInvite: string;
  adminInviteAll: string;
  adminDelete: string;
  adminNoEntries: string;
  adminInvited: string;
  adminInviteSuccess: string;
  adminInviteAllSuccess: string;
  adminDeleteSuccess: string;
  statusUnconfirmed: string;
  statusPending: string;
  statusInvited: string;
  statusConverted: string;
  statusRemoved: string;
  waitlistEnabled: string;
  waitlistToggle: string;
  successCheckEmail: string;
  confirmPageTitle: string;
  confirmPageSuccess: string;
  confirmPageError: string;
  confirmPageExpired: string;
  confirmPageLoading: string;
  rateLimited: string;
  resendInviteTitle: string;
  resendInviteSubtitle: string;
  resendInviteButton: string;
  resendInviteSuccess: string;
  resendInviteRateLimited: string;
  resendInviteLink: string;
  badgeLimited?: string;
  badgeFree?: string;
  benefitNoSpam?: string;
  benefitUnsubscribe?: string;
  benefitPriority?: string;
  benefitFree?: string;
  compactSubtitle?: string;
  heroTitle?: string;
  heroSubtitle?: string;
  // Already-on-list confirmation card (cookie-based)
  alreadyOnListTitle?: string;
  alreadyOnListSubtitle?: string;
  alreadyOnListBadge?: string;
  alreadyOnListHint?: string;
  alreadyOnListReset?: string;
  // Pending email confirmation card (cookie + DB status = unconfirmed)
  pendingConfirmationBadge?: string;
  pendingConfirmationTitle?: string;
  pendingConfirmationSubtitle?: string;
  pendingConfirmationCheckSpam?: string;
  pendingConfirmationResend?: string;
  pendingConfirmationResending?: string;
  pendingConfirmationResent?: string;
  pendingConfirmationResendError?: string;
}

export interface Translations {
  header: { title: string; subtitle: string };
  metronome: { title: string; tapTempo: string; timeSignature: string };
  practiceSession: {
    title: string; start: string; stop: string; pause: string; resume: string;
    thisWeek: string; streak: string; days: string; recentSessions: string;
    today: string; weeklyProgress: string; latestSession: string; startFirstSession: string;
    freePractice: string; noRecentSessions: string; editSession: string;
    studioToday: string; readyToPractice: string; sessionRunning: string; sessionPaused: string;
    bestDay: string; avgActiveDay: string; weekEmptyHint: string;
    onboardingTitle: string; onboardingBody: string; onboardingMidiHint: string;
    sessionTitle: string; sessionNotes: string; sessionNotesPlaceholder: string;
    sessionSaved: string; deleteSession: string; sessionDeleted: string;
    duration: string; back: string;
    addExercise: string; exerciseTitle: string; exerciseTitlePlaceholder: string;
    exerciseType: string; typeWarmup: string; typeRudiment: string; typeSong: string;
    sessionItems: string; noSessionItems: string; addToSession: string;
    fromLibrary: string; createNew: string; searchPlaceholder: string; newItemCreated: string;
    convertHint: string;
  };
  premium: { title: string; description: string; unlock: string; badge: string; activeBadge: string; activeDescription: string };
  stats: {
    title: string; last7Days: string; last4Weeks: string;
    total: string; sessions: string; avgPerSession: string;
    streak: string; days: string; minutes: string; hours: string; noSessions: string;
    currentWeek: string; weekPrefix: string;
    milestones: string; nextMilestone: string; dailyGoal: string; goalReached: string;
  };
  nav: { stats: string; drumPattern: string; sessionMode: string; faq: string };
  notFound: { title: string; message: string; backHome: string };
  drumPattern: {
    title: string; subtitle: string; play: string; stop: string;
    bpm: string; metronome: string; clear: string; clearConfirm: string;
    export: string; import: string;
    kick: string; snare: string; hihat: string; openhihat: string; pedalhat: string; hitom: string;
    midtom: string; lotom: string; crash: string; ride: string; splash: string;
    steps16: string; steps32: string; patternSaved: string; patternLoaded: string; patternTruncated: string;
    addTrack: string; removeTrack: string; noTracksMessage: string;
    measures: string;
    patterns: string; myPatterns: string; presets: string;
    savePattern: string; namePlaceholder: string; noPatterns: string;
    deletePattern: string; patternDeleted: string;
    presetRock: string; presetFunk: string; presetShuffle: string;
    presetBossaNova: string; presetReggae: string; presetDnB: string;
    maxPatternsReached: string; premiumPresetsLocked: string; upgradeToPremium: string; premiumPresets: string;
    copyMeasure: string; measureLabel: string; measureCopied: string; moveMeasure: string;
    midi?: {
      connect: string; disconnect: string; device: string; mapping: string;
      learn: string; learning: string; record: string; recording: string; stopRecording: string;
      score: string; tolerance: string; noDevice: string; notSupported: string;
      premiumRequired: string; patternRecorded: string;
      latency: string; latencyHint: string;
      tapTest: string; tapTestStop: string; tapTestApply: string; tapTestHint: string;
      midiSound: string; midiVolume: string;
      wizard: string;
      wizardTitle: string; wizardStep: string;
      wizardHitPrompt: string; wizardMultiZone: string;
      wizardWaiting: string; wizardRestart: string;
      wizardSkip: string; wizardNext: string; wizardFinish: string;
    };
    mute: string; unmute: string; patternVolume: string; countIn: string;
    metronomeSound?: string; classicSynth?: string; premiumLockedShort?: string;
    timelineView?: string; notation?: string;
    moreMeasures?: string; moreMeasuresHint?: string; measureLimitReached?: string;
  };
  auth?: AuthTranslations & {
    dailyGoalLabel?: string;
    username?: string; emailOrUsername?: string;
    usernameTaken?: string; usernameInvalid?: string;
    notifications?: string; emailNotifications?: string;
    notifyStatusChange?: string; notifyNewComment?: string;
    alreadyLoggedIn?: string; goToDashboard?: string; switchUser?: string; adminPanel?: string;
  };
  admin?: AdminTranslations;
  upgrade?: {
    title: string; heroTitle: string; heroSubtitle: string;
    monthly: string; yearly: string; lifetime: string; perMonth: string; perYear: string; oneTime: string;
    freeDesc: string; premiumDesc: string; currentPlan: string; recommended: string;
    subscribe: string; yearlySaving: string; lifetimeDesc: string; alreadyPremium: string; manageSubscription: string;
    successTitle: string; comparisonTitle: string; feature: string;
    featurePatterns: string; featureMetronome: string; featureStats: string;
    featureMidi: string; featurePremiumPresets: string; featureUnlimited: string; featureRecording: string;
    featureMeasures?: string;
    featureRecordingTime?: string;
    featurePracticeTracker: string;
    backToPlans?: string;
    checkoutTitle?: string;
    estimatedPriceNotice?: string;
  };
  practiceTracker?: PracticeTrackerTranslations;
  dataReset?: DataResetTranslations;
  cookieConsent?: CookieConsentTranslations;
  imprint?: ImprintTranslations;
  privacy?: PrivacyTranslations;
  feedback?: FeedbackTranslations;
  subscription?: SubscriptionTranslations;
  waitlist?: WaitlistTranslations;
}

export type Locale = "de" | "en";

import de from "./de";
import en from "./en";

export const translations: Record<Locale, Translations> = { de, en };
